
import {Component, Prop, Vue} from "vue-property-decorator";
import {stringify} from "@/auxillary/datafield.stringify";
import dataFieldTypesReadonly from "@/dataFieldReadonlyTypes";
import ReadonlyDataField from "@/models/ReadonlyDataField";

@Component({
  name: 'ListEntryFieldReadonly',
  components: {
    ...dataFieldTypesReadonly,
  },
})
export default class ListEntryFieldReadonly extends Vue {

  @Prop({required: true})
  private dataField: ReadonlyDataField

  get isVisible() {
    return this.dataField?.isVisible ?? false;
  }

  get childNames() {
    return this.dataField.definition.names ?? [{
      template: "{0}",
      field: ["name"]
    }];
  }

  get childName() {

    let name = "";

    for (const childName of this.childNames) {
      // find field
      let field: any = undefined;
      for (const fieldIdentifier of childName.field) {
        if (field === undefined) {
          field = this.childFields.find(d => d.identifier == fieldIdentifier)
          if (field === undefined)
            break;
          continue;
        }

        field = field.childFields.find((d: any) => d.identifier == fieldIdentifier)
        if (field === undefined)
          break;
      }
      if (field?.values == null)
        continue;

      const fieldName = stringify(field);
      if (fieldName)
        name += childName.template.replace("{0}", fieldName);
    }

    if (name == "")
      return "(keine Eintragung)";

    return name;
  }

  get displayName() {
    return this.dataField?.displayName;
  }

  get stringifyValue() {
    return stringify(this.dataField)
  }

  get childFields() {
    return this.dataField?.childFields ?? [];
  }
}
